import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Skeleton } from './components/Skeleton';
import { Menu } from './components/Menu';
import { Mobile } from './components/Mobile';
import styles from './Header.module.scss';
import { getLocalPath } from '../../../utils/getLocatPath/getLocalPath';

export const Header = ({ uiBlocks }) => {
  const [isMobMenu, setIsMobMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const params = useParams();
  const { lang } = useParams();
  const upHeader = !!uiBlocks ? uiBlocks.find((el) => el.id === 11) : false;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 25);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!upHeader) {
    return (
      <header className={`${styles.header} ${isScrolled ? 'active' : ''}`}>
        <Skeleton height={70} borderRadius={10} />
      </header>
    );
  }

  const getFilterUrlLink = (link, cour_title = null) => {
    if (!link) {
      return link;
    }
    if (link === 'form/course-enroll') {
      return getLocalPath(`form/course-enroll?cour=${cour_title}`, lang);
    }
  };

  return (
    <header className={`${styles.header} ${isScrolled ? 'active' : ''}`}>
      <Menu upHeader={upHeader} setIsMobMenu={setIsMobMenu} getFilterUrlLink={getFilterUrlLink} />
      <Mobile upHeader={upHeader} isMobMenu={isMobMenu} setIsMobMenu={setIsMobMenu} getFilterUrlLink={getFilterUrlLink} />
    </header>
  );
};
